import { memo } from 'react';
import { EApplicantOfferPGKeys } from 'api-paths-cas';
import { TableCellProps } from '../../../types';
import { Flex } from '@chakra-ui/react';
import { defaultHeaderRenderer } from '../../headers';
import { IColumn } from '../../types';
import { getDays } from '../helpers';

const Formatter = memo(function formatter(cellProps: TableCellProps) {
  return (
    <Flex height="100%" width="100%" flexDirection={'column'}>
      {getDays(cellProps.row.stageChangeDate)}
    </Flex>
  );
});

export const DaysInStage = (): IColumn => ({
  item: {
    key: EApplicantOfferPGKeys.STAGE_CHANGE_DATE,
    name: 'Days in stage',
    headerRenderer: defaultHeaderRenderer,
    width: 'minmax(128px, 1fr)',
    sortable: true,
    formatter: Formatter,
  },
  visible: () => true,
});
